import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";

import { routes } from "./app-routes";
import {
  RequireLoggedInGuard,
  RequireLoggedOutGuard,
  RequireMagicTokenParamGuard
} from "./guards";
import { UserInfoResolver } from "./resolvers";

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: true,
      enableTracing: false
    })
  ],
  providers: [
    RequireLoggedInGuard,
    RequireLoggedOutGuard,
    RequireMagicTokenParamGuard,
    UserInfoResolver
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
